import { getApiUrls } from "../lib/apiUrl";

export type ExchangeAssessmentPreauthParams = {
  apiUrl: string | null | undefined;
  code: string;
  fetchImpl?: typeof fetch;
};

export type ExchangeAssessmentPreauthResult = {
  token: string;
  impersonated_user_id?: string;
};

export async function exchangeAssessmentPreauth({
  apiUrl,
  code,
  fetchImpl = fetch,
}: ExchangeAssessmentPreauthParams): Promise<ExchangeAssessmentPreauthResult> {
  const normalizedCode = code.trim();
  if (!normalizedCode) {
    throw new Error("Preauth code is required.");
  }

  if (!apiUrl) {
    throw new Error("Assessments API URL is not configured.");
  }

  const response = await fetchImpl(`${apiUrl}/preauth/exchange`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code: normalizedCode }),
  });

  if (!response.ok) {
    let responseError = `Unable to exchange preauth code (${response.status})`;
    try {
      const errorPayload = (await response.json()) as { error?: string };
      if (errorPayload?.error) {
        responseError = errorPayload.error;
      }
    } catch {
      // Ignore unreadable error payloads.
    }
    throw new Error(responseError);
  }

  const payload = (await response.json()) as ExchangeAssessmentPreauthResult;
  const token = payload?.token?.trim();
  if (!token) {
    throw new Error("Preauth exchange did not return a token.");
  }

  return {
    token,
    impersonated_user_id: payload.impersonated_user_id?.trim() || undefined,
  };
}

export function getAssessmentsApiUrlFromEnv(): string | null | undefined {
  return getApiUrls().assessmentsApiUrl;
}
